<template>
    <div class="l-checkbox" :title="tooltip">
        <input :id="`l-checkbox-${_uid}`"
               type="checkbox"
               :checked="isChecked"
               :name="name"
               :value="value"
               @change="onChange">
        <label class="l-checkbox flex" :for="`l-checkbox-${_uid}`">

            <font-awesome-icon v-if="isChecked"
                               icon="check-square"
                               class="l-checkbox__inner l-checkbox__inner--checked self-center" />
            <svg v-if="!isChecked"
                 class="svg-inline--fa fa-square fa-w-14 l-checkbox__inner"
                 aria-hidden="true"
                 focusable="false"
                 viewBox="0 0 448 512">
                <path fill="currentColor"
                      d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"></path>
            </svg>

            <span class="l-checkbox__label self-center">
                <span v-if="label">{{ label }}</span>
                <slot v-else />
            </span>
        </label>
    </div>
</template>

<script>
export default {
  name: "LCheckbox",

  model: {
    prop: "checked",
    event: "change"
  },

  props: {
    checked: Boolean,
    value: [String, Number, Object, Boolean],
    name: String,
    label: String,
    type: String,
    tooltip: String
  },

  computed: {
    isChecked() {
      if (!this.isGroup) return this.checked;
      if (this.$parent.modelValue) {
        if (typeof this.value === "object") {
          return !!this.$parent.modelValue.find(
            item => item.id === this.value.id
          );
        }
        if (typeof this.value === "string" || typeof this.value === "number") {
          return !!this.$parent.modelValue.find(item => item === this.value);
        }
      }
      return false;
    }
  },

  methods: {
      onChange() {

      if (this.disabled) return;
      if (!this.isGroup) return this.$emit("change", !this.checked);

      if (!this.isChecked) {
        this.$parent.value.push(this.value);
      } else {
        this.$parent.value.find(item => {
          if (typeof this.value === "object") {
            this.$nextTick(() => {
              if (item.id === this.value.id)
                this.$parent.value.splice(this.$parent.value.indexOf(item), 1);
            });
          }
          if (
            typeof this.value === "string" ||
            typeof this.value === "number"
          ) {
            this.$nextTick(() => {
              if (item === this.value)
                this.$parent.value.splice(this.$parent.value.indexOf(item), 1);
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="postcss">
.l-checkbox {
  @apply cursor-pointer;
  @apply text-xs text-pastel-black;
  display: inline-table;
}

.l-checkbox__label {
  @apply leading-tight;
}

.l-checkbox__inner {
  @apply text-base text-gray-500 mr-1;
}
.l-checkbox__inner--checked {
  @apply text-pastel-green-500;
}

.l-checkbox input {
  display: none;
}
</style>
